import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';

import { BaseSpinner } from './BaseSpinner';

interface ConditionPickerViewListFooterProps {
  hasMore: boolean;
  isFetchingMore: boolean;
  filteredQuestsLength: number;
}

export const ConditionPickerViewListFooter: FC<ConditionPickerViewListFooterProps> = ({
  hasMore,
  isFetchingMore,
  filteredQuestsLength
}) => {
  return (
    <>
      {!hasMore && filteredQuestsLength > 0 && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          padding: '20px',
          color: 'var(--tg-theme-hint-color)'
        }}>
          <Text style={{ fontSize: '14px' }}>
            No more quests to load
          </Text>
        </Box>
      )}
      
      {isFetchingMore && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          padding: 2,
          minHeight: '60px'
        }}>
          <BaseSpinner size="m" />
        </Box>
      )}
    </>
  );
};
